import { observer } from "mobx-react";
import { ShareholderRights, ShareholderRightsModel } from "./increaseOfShareCapitalDomain";
import { VBox } from "@/components-v2/Box";
import { RadioButtonGroup } from "@/components-v2/RadioButton";
import { identity } from "lodash";

import { useTranslation } from "@/stores/RootStoreContext";

export const ReceiveShareholderRights = observer(function ({
  shareholderRights,
  isProjectLocked,
}: {
  shareholderRights: ShareholderRightsModel;
  isProjectLocked: boolean;
}) {
  const { t } = useTranslation();
  return (
    <VBox>
      <div>
        {t(
          "decisions.increaseShareCapitalAgainstCash.newShares.shareholderRightsDate.questionText",
        )}
      </div>
      <RadioButtonGroup
        name={"increaseShareCapitalAgainstCashShareholderRights"}
        options={[
          ShareholderRights.FROM_REGISTRATION_DATE,
          ShareholderRights.FROM_SUBSCRIPTION_DATE,
        ]}
        idFn={identity}
        labelFn={(value) =>
          value === "FROM_REGISTRATION_DATE"
            ? t(
                "decisions.increaseShareCapitalAgainstCash.newShares.shareholderRightsDate.fromRegistration",
              )
            : t(
                "decisions.increaseShareCapitalAgainstCash.newShares.shareholderRightsDate.fromSubscription",
              )
        }
        onChange={(_, option) => shareholderRights.setValue(option)}
        selected={shareholderRights.value}
        disabled={isProjectLocked}
        error={shareholderRights.error}
      />
    </VBox>
  );
});
